import script from "./SsoVrtButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SsoVrtButton.vue?vue&type=script&setup=true&lang=js"

import "./SsoVrtButton.vue?vue&type=style&index=0&id=61cf4326&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cf4326"]])

export default __exports__